import { render, staticRenderFns } from "./Connections.vue?vue&type=template&id=2ac5d99b&scoped=true&"
var script = {}
import style0 from "./Connections.vue?vue&type=style&index=0&id=2ac5d99b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac5d99b",
  null
  
)

export default component.exports